<div class="asset-selector-layout">
	<div class="header mb-5 flex" *ngIf="copy.title && ui.showHeader !== false">
		<div class="left">
			<h1 class="mat-dialog-title left">{{ copy.title }}</h1>
			<div class="copy" *ngIf="copy.copy">{{ copy.copy }}</div>
		</div>
		<button
			mat-flat-button
			color="primary"
			class="button-border-radius right"
			*ngIf="ui.showAddButton"
			[disabled]="false"
			(click)="openTemplateCreationDialog()"
		>
			<mat-icon inline>add</mat-icon>
			<span i18n="Add Element Button@@assetTemplateSelectorAddElementButtonLabel">Add {{ copy.elementTitle }}</span>
		</button>

		<button mat-flat-button color="secondary" class="button-border-radius ml-3" *ngIf="ui.showImportButton" (click)="importTemplate()">
			<ng-container i18n="Import Package Button@@adEditorImportPackageButton">Import Template</ng-container>
		</button>

		<div class="template-dialog-close-button" *ngIf="ui.showCancelButton" [class.only-button]="!ui.showAddButton">
			<button mat-flat-button color="tertiary" (click)="cancel.emit()">
				<mat-icon inline>close</mat-icon>
			</button>
		</div>
	</div>
	<div class="grid h-100">
		<div class="row layout-row h-100">
			<!-- <div class="column col-3" *ngIf="ui.showCategory || ui.showRecent || ui.showAddButton">
				<div class="sidebar">
						<div class="pb-2 sidebar-filters" >
						<div class="sidebar-group mt-2 pb-3" *ngIf="ui.showRecent">
							<div class="sidebar-item active" [ngClass]="{'active' : !this.currentFilters?.showRecent}" (click)="onSelectRecentFilter(false)">
								<span class="ml-2">All {{copy.elementTitlePlural | titlecase}}</span>
							</div>
							<div class="sidebar-item" [ngClass]="{'active' : !!this.currentFilters?.showRecent}" (click)="onSelectRecentFilter(true)">
								<span class="ml-2">{{copy.recentTitle}}</span>
							</div>
						</div>
						<mat-accordion multi="true" *ngIf="ui.showCategory">
							<mat-expansion-panel class="category-panel" [expanded]="isFirst" *ngFor="let category of categories; let isFirst = first">
								<mat-expansion-panel-header>
									<mat-panel-title>{{category.name}}</mat-panel-title>
								</mat-expansion-panel-header>

								<div class="sidebar-group mt-2 pb-0">
									<div class="sidebar-item" *ngFor="let subCategory of category.children" (click)="onSelectSubCategory(category, subCategory)" [ngClass]="{'active' : this.currentFilters?.categories[category.slug]?.id === subCategory?.id}">
										<span class="ml-2">{{subCategory.name}}</span>
									</div>
								</div>
							</mat-expansion-panel>
						</mat-accordion>
					</div>

				</div>
			</div> -->

			<div class="column selection-container">
				<div class="filters flex" [formGroup]="filterForm" *ngIf="ui.showFilter">
					<div class="search left">
						<mat-form-field class="form-control form-field dark-color full-width" appearance="fill">
							<mat-label i18n="Search Projects Label@@projectsListFilterSearchProjectsLabel">Search</mat-label>
							<input matInput formControlName="search" />
							<mat-icon matPrefix>search</mat-icon>
						</mat-form-field>
					</div>
					<div class="right">
						<div class="view-mode" *ngIf="viewModeOptions?.length > 1">
							<mat-button-toggle-group [value]="viewMode" (change)="setViewMode($event.value)">
								<ng-container *ngFor="let option of viewModeOptions">
									<mat-button-toggle [value]="option">
										<mat-icon>{{ AssetTemplateSelectViewMode.getViewModeIcon(option) }}</mat-icon>
									</mat-button-toggle>
								</ng-container>
							</mat-button-toggle-group>
						</div>

						<!-- <button mat-flat-button color="primary" class="block button-border-radius" *ngIf="ui.showAddButton" (click)="add.emit()">
							<mat-icon inline>add</mat-icon>
							<span i18n="Add Element Button@@assetTemplateSelectorAddElementButtonLabel">Add {{copy.elementTitle}}</span>
						</button> -->
					</div>
				</div>

				<div #resultsContainer class="results-container pr-2 pb-2">
					<div class="results">
						<ng-container *ngIf="ui.showFeatured && ui.groupByCategory">
							<ng-container
								*ngIf="elements | filterArray : elementFilterFn : currentFilters : true | arrayOrDefault as featured"
							>
								<div class="selection-category featured">
									<mat-icon class="mr-3" aria-hidden="false">star</mat-icon>
									{{ copy.featuredTitle }}
								</div>
								<div
									[ngClass]="
										viewMode === 'card'
											? 'template-cards-flex'
											: AssetTemplateSelectViewMode.getSelectionClass(viewMode)
									"
								>
									<ng-container *ngIf="viewMode === 'list' || viewMode === 'card'">
										<ng-template
											*ngFor="let element of featured; let i = index"
											[ngTemplateOutlet]="viewMode === 'list' ? listElement : cardElement"
											[ngTemplateOutletContext]="{ element: element, index: i }"
										></ng-template>
									</ng-container>

									<ng-container *ngIf="viewMode === 'table'"></ng-container>
								</div>
							</ng-container>
						</ng-container>

						<ng-container>
							<div
								[ngClass]="
									viewMode === 'card' ? 'template-cards-flex' : AssetTemplateSelectViewMode.getSelectionClass(viewMode)
								"
							>
								<ng-container *ngIf="viewMode === 'list' || viewMode === 'card'">
									<app-collection-container
										[collection]="gridCollection"
										(onLinkedOutput)="selectFromTable($event.entity, true)"
										(eventOutput)="handleTableEvents($event)"
									>
										<ng-template #customTemplate let-entity>
											<ng-container
												[ngTemplateOutlet]="viewMode === 'list' ? listElement : cardElement"
												[ngTemplateOutletContext]="{ element: entity }"
											></ng-container>
										</ng-template>
									</app-collection-container>
								</ng-container>

								<ng-container *ngIf="viewMode === 'table'">
									<app-collection-container
										[collection]="tableCollection"
										(onLinkedOutput)="selectFromTable($event.entity, true)"
										(eventOutput)="handleTableEvents($event)"
									></app-collection-container>
								</ng-container>
							</div>
						</ng-container>

						<!-- <ng-container *ngIf="(elements | filterArray: elementFilterFn: currentFilters: undefined) | transformObject: groupElements: 'subCategory' | arrayOrDefault as groups else noResults">
							<ng-container *ngFor="let group of groups">
								<div class="selection-category" *ngIf="ui.groupByCategory">
									{{group.key.name}}
								</div>

								<div [ngClass]="{'selections-list': viewMode === 'list', 'selections-cards': viewMode !== 'list'}">
									<ng-template *ngFor="let element of group.elements" [ngTemplateOutlet]="viewMode === 'list' ? listElement :  cardElement" [ngTemplateOutletContext]="{element: element}"></ng-template>
								</div>
							</ng-container>
						</ng-container> -->

						<ng-template #noResults>
							<div class="text-center">
								<p *ngIf="copy.noResultsText">{{ copy.noResultsText }}</p>
								<p *ngIf="!copy.noResultsText" i18n="No Results Message@@assetTemplateSelectorNoResultsMessage">
									No results found.
								</p>
							</div>
						</ng-template>
					</div>

					<ng-template #cardElement let-element="element" let-index="index">
						<div
							class="template-card-shared"
							[ngClass]="{ selected: selectedElementIds.includes(element.id) }"
							(click)="toggleSelection(element, !ui.showSubmitButton)"
						>
							<div
								class="template-card-thumbnail"
								[class.placeholder]="!element.thumbnail?.assetPath"
								[ngClass]="!element.thumbnail?.assetPath ? getPlaceholderClass(element.name, index) : ''"
								[style.background-image]="
									element.thumbnail?.assetPath
										? (element.thumbnail?.assetPath
										  | transformObject : getCloudinaryThumbnail
										  | transformObject : generateBackground : selectedElementIds.includes(element.id))
										: 'none'
								"
							>
								<div class="template-card-overlay">
									<button
										*ngIf="ui.showPinButton"
										class="template-card-button pin-button"
										[class.pinned]="element.isPinned"
										(click)="handlePinToggle(element, $event)"
									>
										<mat-icon>{{ element.isPinned ? 'push_pin' : 'push_pin' }}</mat-icon>
									</button>
									<button
										*ngIf="ui.showPackageMenuActions"
										class="template-card-button more-button"
										(click)="$event.preventDefault(); $event.stopPropagation()"
										[matMenuTriggerFor]="contextMenu"
									>
										<mat-icon>more_horiz</mat-icon>
									</button>
								</div>

								<mat-menu #contextMenu="matMenu" class="tiny">
									<div
										*ngIf="ui.showPinButton"
										mat-menu-item
										(click)="handlePinToggle(element, $event)"
										class="thumbnail-card-context-menu"
									>
										<mat-icon>{{ element.isPinned ? 'push_pin' : 'bookmark_border' }}</mat-icon>
										<ng-container>{{ element.isPinned ? 'Unpin' : 'Pin' }}</ng-container>
									</div>
									<div mat-menu-item (click)="exportPackage(element)" class="thumbnail-card-context-menu" *ngIf="canExportTemplate()">
										<mat-icon>file_open</mat-icon>
										<ng-container i18n="Export Package Button@@adEditorExportPackageButton">Export</ng-container>
									</div>
									<div mat-menu-item (click)="removeFromTable(element)" class="thumbnail-card-context-menu">
										<mat-icon>delete</mat-icon>
										<ng-container i18n="Layer Action@@adLayerRowRemove">Remove</ng-container>
									</div>
								</mat-menu>
							</div>

							<mat-menu #contextMenu="matMenu" class="tiny">
								<div mat-menu-item (click)="exportPackage(element)" class="thumbnail-card-context-menu">
									<mat-icon>file_open</mat-icon>
									<ng-container i18n="Export Package Button@@adEditorExportPackageButton">Export</ng-container>
								</div>
								<div mat-menu-item (click)="removeFromTable(element)" class="thumbnail-card-context-menu">
									<mat-icon>delete</mat-icon> <ng-container i18n="Layer Action@@adLayerRowRemove">Remove</ng-container>
								</div>
							</mat-menu>
							<div class="clip-info">
								<!-- <div class="name">{{ element.name }}</div> -->
								<div class="type" *ngIf="ui.showFileType">{{ element.fileType }}</div>

								<div class="icons">
									<div class="duration" *ngIf="element.duration">{{ element.duration }}</div>
								</div>
							</div>
							<div class="card-container-bottom">
								<div class="tags" *ngIf="element.tags?.length">
									<mat-chip-list
										aria-label="Clip tags"
										i18n-aria-label="Clip Tags@@assetTemplateSelectorClipTagsLabel"
										class="tags-list"
									>
										<mat-chip *ngFor="let tag of element.tags" class="tag-item">{{ tag }}</mat-chip>
									</mat-chip-list>
								</div>
								<!-- <div class="card-actions">
									<button mat-flat-button color="primary" class="block" (click)="toggleSelection(element)">{{ selectedElementIds.includes(element.id) ? 'Remove' : 'Select'}}</button>
									<button mat-button class="block" *ngIf="ui.showPreview" [tp]="element.previewUrl ? filePreview : undefined" [tpData]="element" tpPlacement="bottom" tpClassName="video-preview-tooltip">Preview</button>
								</div> -->
								<div class="template-card-info">
									<h4 class="template-card-name">{{ element.name }}</h4>
									<div class="template-card-meta">
										<span class="template-card-date" *ngIf="element.modified">
											Modified {{ formatDate(element.modified) }}
										</span>
										<div class="template-card-tags" *ngIf="element.tags?.length">
											<span class="template-card-tag" *ngFor="let tag of element.tags">{{ tag }}</span>
										</div>
										<span class="template-card-type" *ngIf="ui.showFileType">{{ element.fileType }}</span>
										<span class="template-card-duration" *ngIf="element.duration">{{ element.duration }}</span>
									</div>
								</div>
							</div>
						</div>
					</ng-template>

					<ng-template #listElement let-element="element">
						<div class="list-item-container" [ngClass]="{ selected: selectedElementIds.includes(element.id) }">
							<div class="list-selection cursor-pointer">
								<mat-icon (click)="toggleSelection(element, !ui.showSubmitButton)">{{
									selectedElementIds.includes(element.id) ? 'check_box' : 'check_box_outline_blank'
								}}</mat-icon>
							</div>
							<div class="clip-info">
								<div class="name">{{ element.name }}</div>
								<div class="type" *ngIf="ui.showFileType">{{ element.fileType }}</div>

								<div class="tags" *ngIf="element.tags?.length">
									<mat-chip-list
										aria-label="Clip tags"
										i18n-aria-label="Clip Tags@@assetTemplateSelectorClipTagsLabel"
										class="tags-list"
									>
										<mat-chip *ngFor="let tag of element.tags" class="tag-item">{{ tag }}</mat-chip>
									</mat-chip-list>
								</div>
							</div>
							<div class="list-actions">
								<!-- <button mat-button class="block" *ngIf="ui.showPreview" [tp]="element.previewUrl ? filePreview : undefined" [tpData]="element"  tpPlacement="bottom" tpClassName="video-preview-tooltip">Preview</button> -->
							</div>
						</div>
					</ng-template>

					<ng-template #filePreview let-element="data">
						<div [ngSwitch]="element.fileType">
							<video *ngSwitchCase="'video'" [src]="element.previewUrl" [muted]="true" autoplay loop></video>
							<img *ngSwitchCase="'image'" [src]="element.previewUrl" />
							<img *ngSwitchCase="'logo'" [src]="element.previewUrl" />
							<div *ngSwitchDefault i18n="No Preview Message@@assetTemplateSelectorNoPreviewMessage">
								No preview available
							</div>
						</div>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</div>
